<template>
    <v-layout align-start 
                justify-start 
                row wrap 
                >
        <v-flex :class="attributes.size">   
               
            <v-autocomplete                        
                :label="attributes.placeholder"                                
                light                                                                                                              
                :items="items"     
                :item-text="attributes.displaytitle"
                item-value="id"
                v-model="result"                                                                
                flat
                chips
                dark
                clearable
                :prepend-inner-icon="attributes.icon"
                :multiple="attributes.multiple"                
                @change="changeResult"
                
                >    
                <template
                    slot="selection"                    
                    slot-scope="data"                    
                    >
                    <v-chip
                        :selected="data.selected"
                        close
                        small
                        class="chip--select-multi lime darken-4"
                        @input="remove(data.item)"
                    >                  
                        {{ getTitle(data.item) }}
                    </v-chip>
                </template> 
                <template
                    slot="item"
                    slot-scope="data"
                    >
                    <template v-if="typeof data.item !== 'object'">
                        <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="getTitle(data.item)"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="getSubTitle(data.item)"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </template>
                </template>
            </v-autocomplete>                                                                                                                
        </v-flex>
        <v-flex xs1></v-flex> 
        <v-flex :class="attributes.invertedsize">
                    
        </v-flex>        
        
    </v-layout>
</template>
<script>
import formselectsingleresult from "./FormSelectSingleResult.vue"
import formselectmultiresult from "./FormSelectMultiResult.vue"
import { mapGetters } from 'vuex';
export default {   
    
    props:[
        'attributes',
        'vuexnamespace'
    ],
    components: {
        formselectsingleresult: formselectsingleresult,
        formselectmultiresult: formselectmultiresult,        
        
    },
    data() {
        return {
            formselectsingleresult:formselectsingleresult,
            formselectmultiresult: formselectmultiresult,                        
            formselectrules:[], 
            result:[]            
        }
    },
    watch:{
        result() {
            this.$emit('input',this.result)
        }
    },
    computed: {
        
        itemsnamespace: function() {
            return this.attributes.items.split('/')[0]
        },
        itemsformdata: function(){
            return this.$store.getters[this.itemsnamespace + '/formdata']
        },
        items: function() {            
            return this.$store.getters[this.attributes.items]        
        },
                  
                        
    },
    methods: {
        
        isObject(o) {
            return o !== null && typeof o === 'object' && Array.isArray(o) === false;
        },
        
        getTitle (item) {
            return item[this.attributes.displaytitle]
        },
        getSubTitle (item) {
            return item[this.attributes.displaysubtitle]
        },
        onDialogToggled() {                
            this.dialog = !this.dialog
        },
        
        remove (item) {
           
            if(Array.isArray( this.result)) {                                  
                const index = this.result.indexOf(item.id)
                if (index >= 0) this.result.splice(index, 1) 
            } else {
                this.result=null
            }
         
        } ,
        changeResult(item) {            
            this.result=item
        }
    },
    mounted(){
        this.$store.dispatch(this.itemsnamespace + '/getAll')
    }
    
}
</script>